<dialog-header
  title="Issue Voucher"
  (onClose)="matDialogRef.close()"
></dialog-header>

<div
  mat-dialog-content
  style="
    border-top: 1px solid lightgray;
    border-bottom: 1px solid lightgray;
    background-color: var(--app-container);
  "
>
  <form [formGroup]="form" style="margin-top: 20px">
    <div class="form-field">
      <single-select
        label="Voucher Type"
        [formCtrl]="voucherFormControl"
        [value]="voucherFormControl.value"
        [options]="vouchers"
        property="displayAs"
        [showIcon]="false"
        (click)="hasVouchers()"
      ></single-select>
    </div>

    <div class="form-field" style="margin-top: 20px">
      <single-select
        label="Issue To"
        [formCtrl]="recipientTypeFormControl"
        [value]="recipientTypeFormControl.value"
        [options]="recipientTypeOptions"
        property="label"
        [showIcon]="false"
      ></single-select>
    </div>

    <div class="form-field" style="margin-top: 20px" *ngIf="isSpecificCustomer">
      <single-select
        label="Customer"
        inBrackets="email"
        [formCtrl]="customerFormControl"
        [value]="customerFormControl.value"
        [options]="customers"
        property="name"
        [showIcon]="false"
        [showSearch]="true"
      ></single-select>
    </div>

    <div class="form-field" style="margin-top: 20px" *ngIf="isEmailRecipient">
      <div class="form-field-label">
        Recipient Email<span style="color: red">*</span>
      </div>
      <input
        class="form-input"
        autocomplete="off"
        [formControl]="emailFormControl"
        type="email"
        placeholder="Enter recipient email address"
      />
    </div>

    <div class="form-field" style="margin-top: 20px" *ngIf="isEmailRecipient">
      <div class="form-field-label">
        Recipient Name<span style="color: red">*</span>
      </div>
      <input
        class="form-input"
        autocomplete="off"
        [formControl]="nameFormControl"
        type="text"
        placeholder="Enter recipient name"
      />
    </div>

    <div class="form-field" style="margin-top: 20px" *ngIf="isGeneralVoucher">
      <div class="form-field-label">
        Recipient Email
        <span *ngIf="isSpecificCustomer" style="color: red">*</span>
        <span *ngIf="!isSpecificCustomer" style="color: gray">(Optional)</span>
      </div>
      <input
        class="form-input"
        autocomplete="off"
        [formControl]="emailFormControl"
        type="email"
        placeholder="Enter recipient email (optional for charity vouchers)"
      />
    </div>

    <div class="form-field" style="margin-top: 20px" *ngIf="isGeneralVoucher">
      <div class="form-field-label">
        Recipient Name
        <span *ngIf="isSpecificCustomer" style="color: red">*</span>
        <span *ngIf="!isSpecificCustomer" style="color: gray">(Optional)</span>
      </div>
      <input
        class="form-input"
        autocomplete="off"
        [formControl]="nameFormControl"
        type="text"
        placeholder="Enter recipient name (optional for charity vouchers)"
      />
    </div>

    <div class="form-field" style="margin-top: 20px">
      <single-select
        label="Quantity"
        [formCtrl]="quantityFormControl"
        [value]="quantityFormControl.value"
        property="number"
        [options]="quantityOptions"
        [showIcon]="false"
      ></single-select>
    </div>

    <div
      class="form-field"
      style="margin-top: 20px; display: flex; justify-content: space-between"
      *ngIf="isSpecificCustomer"
    >
      <div class="form-field-label">Send a push notification</div>
      <mat-slide-toggle
        [disabled]="false"
        [checked]="sendPushNotification"
        (change)="sendPushNotification = !sendPushNotification"
      >
      </mat-slide-toggle>
    </div>

    <div
      class="form-field"
      style="margin-top: 20px; display: flex; justify-content: space-between"
      *ngIf="isEmailRecipient"
    >
      <div class="form-field-label">Send email immediately</div>
      <mat-slide-toggle
        [disabled]="false"
        [checked]="sendEmail"
        (change)="sendEmail = !sendEmail"
      >
      </mat-slide-toggle>
    </div>
  </form>
</div>

<div mat-dialog-actions align="end">
  <app-secondary-button
    style="margin-right: 10px"
    [title]="'Cancel'"
    [disabled]="saving"
    (tapped)="matDialogRef.close()"
  ></app-secondary-button>

  <app-primary-button
    [title]="'Issue Voucher'"
    [disabled]="saving || form.invalid"
    (tapped)="issueVoucher()"
    bgColor="var(--app-timber)"
    color="white"
  ></app-primary-button>
</div>

<loader [loading]="loading || saving"></loader>
